import { createFileRoute, notFound } from '@tanstack/react-router';
import { RouteName, TextKey } from '@mews-commander/enums';
import {
    GuestExperienceEnterpriseList,
    isAllowedAccessEmailWhitelistingRoutes,
} from '@mews-commander/modules/src/modules/guestExperienceWhitelistedUserEmails';
import { MewsTeam, RouteType } from '@mews/enums';

const Component = () => <GuestExperienceEnterpriseList />;

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/GuestExperience/Enterprises')({
    component: Component,
    beforeLoad: () => {
        if (!isAllowedAccessEmailWhitelistingRoutes()) {
            throw notFound();
        }
    },
    staticData: {
        routeName: RouteName.GuestExperienceEnterprises,
        owner: MewsTeam.GuestExperience,
        type: RouteType.Frontend,
        title: TextKey.WhitelistedUserEmailsEnterprisesPageTitle,
    },
});
